export const onEnter = (onEnterFn: () => void) => (e: React.KeyboardEvent) => {
    if (e.code === 'Enter') {
        e.preventDefault();
        onEnterFn();
    }
};
